import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Drop-in replacement for a <video> player area when attachHls() reports
 * 'unavailable' (repeated HLS manifest/fragment 404s — the stream isn't
 * currently publishing) instead of leaving a blank/broken player with only
 * a console error. `compact` tightens it for a small grid tile; the full
 * size is for a stream's own detail/preview page.
 */
const StreamUnavailable = ({ compact = false, className = '', heightClass = 'tw-h-44' }) => {
  const navigate = useNavigate();

  if (compact) {
    return (
      <div className={`tw-flex ${heightClass} tw-w-full tw-flex-col tw-items-center tw-justify-center tw-gap-1.5 tw-bg-ink-900 tw-px-4 tw-text-center ${className}`}>
        <i className="fa-solid fa-satellite-dish tw-text-lg tw-text-content-faint" />
        <div className="tw-text-xs tw-font-semibold tw-text-content-muted">Stream currently unavailable</div>
        <button
          type="button"
          onClick={() => navigate('/tickets/new')}
          className="tw-text-[0.7rem] tw-font-semibold tw-text-brand hover:tw-underline"
        >
          Raise a ticket
        </button>
      </div>
    );
  }

  return (
    <div className={`tw-flex tw-min-h-[280px] tw-w-full tw-flex-col tw-items-center tw-justify-center tw-gap-3 tw-bg-ink-900 tw-px-6 tw-py-10 tw-text-center ${className}`}>
      <div className="tw-flex tw-h-14 tw-w-14 tw-items-center tw-justify-center tw-rounded-2xl tw-bg-ink-800 tw-text-xl tw-text-content-faint">
        <i className="fa-solid fa-satellite-dish" />
      </div>
      <h3 className="tw-text-base tw-font-semibold tw-text-heading">Stream currently unavailable</h3>
      <p className="tw-max-w-sm tw-text-sm tw-text-content-muted">
        This stream isn't publishing right now, so there's nothing to play. If you're the broadcaster
        and unable to go live, or you think this is a technical error, raise a ticket or email us —
        we're glad to help.
      </p>
      <div className="tw-mt-1 tw-flex tw-flex-wrap tw-items-center tw-justify-center tw-gap-2">
        <button
          type="button"
          onClick={() => navigate('/tickets/new')}
          className="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-[10px] tw-bg-brand tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-transition hover:tw-opacity-90"
        >
          <i className="fa-solid fa-ticket" /> Raise a ticket
        </button>
        <a
          href="mailto:support@teve.ca"
          className="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-[10px] tw-bg-ink-800 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-content tw-transition hover:tw-bg-ink-750"
        >
          <i className="fa-solid fa-envelope" /> support@teve.ca
        </a>
      </div>
    </div>
  );
};

export default StreamUnavailable;
